import { Link } from "react-router-dom";
import styles from "./BoardDetail.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function BoardDetail({ data }) {
  if (!data) {
    return null; // 또는 로딩 UI / 에러 UI
  }

  return (
    <div className={cx("boardDetailWrap")}>
      <div className={cx("boardHeader")}>
        <h3 className={cx("boardDetailTitle")}>{data.title}</h3>
        <div className={cx("inforWrap")}>
          <div className={cx("inforItem")}>
            <span className={cx("label")}>작성자</span>
            <span className={cx("value")}>{data.writer}</span>
          </div>
          <div className={cx("divider")}></div>
          <div className={cx("inforItem")}>
            <span className={cx("label")}>작성일</span>
            <span className={cx("value")}>{data.date}</span>
          </div>
        </div>
      </div>

      <div className={cx("detailContentWrap")}>{data.content}</div>

      <div className={cx("btnWrap")}>
        <Link to="/archive/notice" className={cx("listBtn")}>
          목록으로
        </Link>
      </div>
    </div>
  );
}
